<div *ngIf="isnoEvaluate" class="card m-b-10">
    <div class="card-body pt-0">
        <div class="row">
            <div class="col-12 no-evaluate d-flex align-items-center justify-content-center">
                    {{ 'lang.reporting.noReports' | translate }}
            </div>
        </div>
    </div>
</div>
<ng-container *ngIf="isviewReport">
    <div class="card m-b-10" *ngFor="let process of (completedProcesses$ | async)">
        <div class="card-body">
            <div class="row">
                <div class="col-5 pr-0">
                    <div>
                        <span class="caption">{{ 'lang.user.appraisee' | translate }}:</span>
                        <span class="font-weight-bold">{{ process.appraiseeDisplayName }}</span>
                    </div>
                    <div>
                        <span class="caption">{{ 'lang.common.startDate' | translate }}:</span>
                        <span>{{process.startDate | date: 'yyyy-MM-dd'}}</span>
                    </div>
                </div>
                <div class="col-5">
                    <div>
                        <span class="caption">{{ 'lang.common.process' | translate }}:</span>
                        <span>{{process.name}}</span>
                    </div>
                </div>
                <div class="col-2 pl-0 text-right">
                    <span class="btn-view" (click)="redirectToInidvidualReport(process.id)">
                        {{ 'lang.reporting.showReport' | translate }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</ng-container>